"use strict";
exports.__esModule = true;
exports.get_first_element_by_class_or_fail = exports.get_element_by_id_or_fail = void 0;
function get_element_by_id_or_fail(id, type) {
    var element = document.getElementById(id);
    if (!(element instanceof type))
        throw new Error('Could not find element with ID ' + id);
    return element;
}
exports.get_element_by_id_or_fail = get_element_by_id_or_fail;
function get_first_element_by_class_or_fail(parent, classname, type) {
    var element = parent.getElementsByClassName(classname).item(0);
    if (!(element instanceof type))
        throw new Error('Could not find element with class ' + classname);
    return element;
}
exports.get_first_element_by_class_or_fail = get_first_element_by_class_or_fail;
